import { useSelector } from 'react-redux';
// Individual selector hooks
export const useActiveObject = () => useSelector((state) => state.decalEditor.activeSelection);
export const useCanvasReset = () => useSelector((state) => state.decalEditor.resetCanvas);
export const useLoadingSignForEdit = () => useSelector((state) => state.decalEditorAPI.loadingSignForEdit);
export const useSignForEdit = () => useSelector((state) => state.decalEditorAPI.signForEdit);
export const useProductTemplate = () => useSelector((state) => state.decalEditorAPI.productTemplate);
export const useIsAddingToCart = () => useSelector((state) => state.decalEditorAPI.addingToCart);
export const useCartError = () => useSelector((state) => state.decalEditorAPI.cartError);
export const useCanvasObjectCount = () => useSelector((state) => state.decalEditor.objectCount);
export const useCanvasSize = () => useSelector((state) => state.decalEditor.canvasSize);
export const useIsEditMode = () => {
    const signForEdit = useSignForEdit();
    return !!signForEdit;
};
export const useIsCanvasEditingLocked = () => useSelector((state) => state.decalEditor.isEditingLocked);
export const useIsProductTemplateModified = () => useSelector((state) => state.decalEditorAPI.productTemplateModified);
export const useIsWindowResized = () => useSelector((state) => state.decalEditor.windowResized);
export const useActiveObjectLocationChanged = () => useSelector((state) => state.decalEditor.activeObjectLocationChanged);
export const useSnappingEnabled = () => useSelector((state) => state.decalEditor.snappingEnabled);
